let personalized_homepage_exp_tracked = {};
let bottom_of_page_event_executed = false
let bottom_of_page_event_timeout
let gift_section_event_executed = false

$(document).ready(function () {
    const $sectionNumbers = $('section.numbers');
    const $sectionValue = $('#new-homepage-value-props');
    const sectionScroll = function () {
        if (!$sectionValue.length) {
            return;
        }

        let currentScroll = 0;
        let sectionTop = $sectionValue.offset().top - 200;
        const onScroll = function () {
            const newScroll = window.scrollY / sectionTop;

            // prevent scrolling up animation and reset when the section is below the viewport
            if (newScroll < currentScroll && newScroll > 0) {
                return;
            }

            $sectionValue[0].style.setProperty('--scroll', newScroll);
            currentScroll = newScroll;
        };
        onScroll();
        return { onScroll };
    }();

    const homeScroll = function (event) {
        $('html, body').animate({
            scrollTop: $(event.currentTarget).offset().top - 17 // + 33 .down-arrow height + 10 margin - 60 header height
        }, 500);
    }

    $(".down-arrow").click(homeScroll);

    $(".down-arrow").keypress(function (e) {
        if (e.keyCode === 32 || e.keyCode === 13) {
            homeScroll(e);
        }
    });

    AOS.init({
        duration: 1200,
    });

    $('.comparison_table_tooltip').each(function () {
        $(this).tooltip({
            placement: 'right',
            title: translateTooltipTitle('<div>' + $(this).data('text') + '</div>'),
            html: true,
            viewport: { "selector": "body", "padding": 8 }
        });
    });

    visibleHeader();

    $('.testimonial-slider').slick({
        dots: true,
        accessibility: true,
        infinite: false,
        adaptiveHeight: false,
        arrows: false,
        swipe: true,
        swipeToSlide: true,
        autoplay: true,
        autoplaySpeed: 7000
    });

    if ($sectionNumbers.length) {
        Counter.init();
    }

    $('#btn-start-individual, #btn-start-couples, #btn-start-teen').on('mousedown', function () {
        $(this).addClass('pressed');
    });

    $('#btn-start-couples').on('click', function () {
        $('#dont-redirect').on('click', function () {
            location = '/get-started/?skip_redirect_question=1';
        });
        $('#refer_to_regain').modal('show');
    });

    $('#refer_to_regain').on('hidden.bs.modal', function () {
        $('#btn-start-couples').removeClass('pressed');
    });

    $('#btn-start-teen').on('click', function () {
        $('#dont-redirect-parent-to-teen').on('click', function () {
            location = '/get-started/?skip_redirect_question=1';
        });
        $('#refer_to_teen').modal('show');
    });

    $('#refer_to_teen').on('hidden.bs.modal', function () {
        $('#btn-start-teen').removeClass('pressed');
    });

    if (!!page_info.account_recovery) {
        $('#modal-account_recovery_sent').modal('show');
    }

    /**
     * Checking if user has scrolled element into view
     * @param elem
     * @returns {boolean}
     */
    function is_scrolled_into_view(elem, offset = 200) {
        const doc_view_top = $(window).scrollTop();
        const doc_view_bottom = doc_view_top + $(window).height();
        const elem_top = $(elem).offset().top;
        const elem_bottom = elem_top + offset;
        return ((elem_bottom <= doc_view_bottom) && (elem_top >= doc_view_top));
    }

    /**
     * ScrollEvent handler.
     */
    function handle_scroll_event() {
        const sections = {
            'faq': '#home_faq_section',
            'below_fold': $sectionNumbers.length ? $sectionNumbers : $sectionValue,
            'how_it_works': '#how_it_works',
            'in_office_comparison': '.comparison-table-wrap',
        };

        for (let section in sections) {
            if (personalized_homepage_exp_tracked[section] !== undefined || !is_scrolled_into_view(sections[section])) {
                continue;
            }

            personalized_homepage_exp_tracked[section] = true;
            if (typeof snowplow !== "undefined") {
                snowplow("trackStructEvent", {
                    category: "homepage",
                    action: `${section}_viewed`
                });
            }
        }

        if (is_scrolled_into_view('#home_gift_section') && !gift_section_event_executed) {
            gift_section_event_executed = true;
            GiftEvent("gift_banner_seen", "banner_seen").send();
        }
        if (Object.keys(personalized_homepage_exp_tracked).length >= 2 && gift_section_event_executed) {
            window.removeEventListener('scroll', handle_scroll_event);
        }
    }

    if ($("#home_faq_section").length > 0 || $sectionNumbers.length > 0 || $("#home_gift_section").length > 0) {
        window.addEventListener('scroll', handle_scroll_event);
    }

    $(window).scroll(function () {
        sectionScroll?.onScroll();

        visibleHeader();

        if ($(this).scrollTop() + $(this).innerHeight() >= document.body.scrollHeight - 50) {
            if (!bottom_of_page_event_executed) {
                bottom_of_page_event_executed = true
                ScrolledToBottomOfHomepageEvent().send()
            }

            clearTimeout(bottom_of_page_event_timeout)
            bottom_of_page_event_timeout = setTimeout(() => bottom_of_page_event_executed = false, 15000)
        }
    })

    $('.social.facebook').click(function (e) {
        SocialLinkClickEvent('facebook').send();
    });
    $('.social.instagram').click(function (e) {
        SocialLinkClickEvent('instagram').send();
    });
    $('.social.tiktok').click(function (e) {
        SocialLinkClickEvent('tiktok').send();
    });
    $('.social.linkedin').click(function (e) {
        SocialLinkClickEvent('linkedin').send();
    });
    $('.social.twitter').click(function (e) {
        SocialLinkClickEvent('twitter').send();
    });
    $('.get-started-btn').click(function (e) {
        BhStructEvent('homepage', 'clicked_find_your_therapist').send();
    });
});
